// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__fD1e2","content":"styles_content__3x9KT","tableWrap":"styles_tableWrap__3GsZd"};